import { Box, Button, Card, CardContent, FormControl, Grid } from '@mui/material'
import { FileManagerInput } from 'common'
import React from 'react'
import { UploadCloud, XCircle } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'
import { CollateralImagesTable } from './CollateralImagesTable'
import { HeaderCollateralImages } from '../CollateralForm/HeaderCollateralImages.jsx'

const acceptConfiguration = {
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
}

export const CollateralImages = ({ useFetchInit }) => {
  const { Actions, Forms, globalStates } = useFetchInit

  const { formOpeningMode } = globalStates
  const isReadOnly = formOpeningMode === 'READONLY'

  const {
    onSubmitCollateralImages,
    handleClickCleanUpCollateralImagesFiles,
    handleClickCloseCollateralImages,
  } = Actions

  const { FormCollateral } = Forms
  const { onDropZoneAcceptedFilesChange, onDropZoneRejectionsFilesChange, formState } = FormCollateral

  return (
    <AllowedAccess permissions={['49_ADMIN', '240_CREDITOS_GARANTIAS']} renderAuthFailed={<p>Error</p>}>
      <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
        <Grid item xs={12}>
          <Card style={{ zIndex: '1' }}>
            <CardContent>
              <div className="h4 mt-1 mb-1">Imagenes de Garantias</div>
              <div className="border-bottom border-dark"></div>

              <HeaderCollateralImages useFetchInit={useFetchInit} />

              <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 5 }}>
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{ mb: 2 }}>
                  <form onSubmit={onSubmitCollateralImages}>
                    <FormControl fullWidth>
                      <label htmlFor="attachmentt"> * Imagenes </label>

                      {/* Igual que paso 2: si READONLY, no renderizar input */}
                      {!isReadOnly && (
                        <FileManagerInput
                          acceptedFiles={formState.acceptedFiles}
                          fileRejections={formState.fileRejections}
                          NameId="attachmentt"
                          typeFiles="IMAGES"
                          maxFiles={5}
                          accept={acceptConfiguration}
                          setAcceptedFiles={onDropZoneAcceptedFilesChange}
                          setFileRejections={onDropZoneRejectionsFilesChange}
                        />
                      )}
                    </FormControl>

                    <div className="text-center">
                      <Button
                        startIcon={<UploadCloud />}
                        variant="contained"
                        type="submit"
                        className="btn-round"
                        color="primary"
                        sx={{ marginRight: 3, marginLeft: 1 }}
                        disabled={isReadOnly}
                      >
                        Subir
                      </Button>

                      <Button
                        startIcon={<XCircle />}
                        variant="contained"
                        type="button"
                        className="btn-round"
                        color="error"
                        onClick={handleClickCleanUpCollateralImagesFiles}
                        sx={{ marginRight: 3, marginLeft: 1 }}
                        disabled={isReadOnly}
                      >
                        Limpiar
                      </Button>
                    </div>
                  </form>
                </Grid>

                <Grid item xs={12} sm={12} md={8} lg={8} sx={{ mb: 2 }}>
                  <CollateralImagesTable useFetchInit={useFetchInit} />
                </Grid>
              </Grid>

              <Box className="text-center" sx={{ mt: 7, mb: 7 }}>
                <Button
                  startIcon={<XCircle />}
                  variant="contained"
                  type="button"
                  className="btn-round"
                  color="error"
                  onClick={handleClickCloseCollateralImages}
                  sx={{ marginRight: 5, marginLeft: 1 }}
                >
                  Cerrar Imagenes
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </AllowedAccess>
  )
}